export enum InputCallbackType { Input, Change, Enter, Escape, Done, Clear }